import { Meta } from "@/shared/components";
import { AssistantConversations } from "@/admin/features/assistantConversations";

export function AssistantConversationsPage() {
  return (
    <>
      <Meta title="Диалоги помощника" />
      <AssistantConversations />
    </>
  );
}
